import React, { useState, useEffect } from "react";
import "./ProviderSelection.css";
import axios from "axios";
import { Link, useLocation, useNavigate } from "react-router-dom";
import StarRating from "./UserPatientScreen/StarRating";
import { API_IP } from "../global_variables";

const CareProviderCard = ({ provider, setSelectedSection }) => {
  const [userRating, setUserRating] = useState(0);
  const navigate = useNavigate();
  const imgList = {
    Jonas: 1,
    "Test Provider": 2,
    "Kha Hoang": 3,
    BetterLifeInc: 2,
    WeCare: 1,
    "Dang Provider": 3,
    KhaThi: 1,
  };

  return (
    <div
      className="PS-card"
      onClick={() => {
        navigate(`/CareProviderProfile?id=${provider.provider_id}`, {
          state: {
            data: provider,
            imgIndex: imgList[provider.provider_name],
          },
        });
      }}
    >
      <div className="PS-card-img-wrapper">
        <img
          src={provider.img_url || require("../images/avatar_placeholder.png")}
          alt={provider.provider_name}
          className="PS-card-img"
        />
      </div>
      <div className="PS-card-content">
        <h2 className="PS-card-name">{provider.provider_name}</h2>
        <p className="PS-card-title">{provider.title}</p>
        <div className="PS-card-hours">
          <span className="PS-hours-label">Hours:</span>
          <span className="PS-hours-value">
            {provider.opening_hour}:00 - {provider.closing_hour}:00
          </span>
        </div>
      </div>
    </div>
  );
};

const ProviderSelection = ({ setSelectedSection }) => {
  const [providers, setProviders] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${API_IP}/api/providers`)
      .then((response) => {
        setProviders(response.data);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
      });
  }, []);

  return (
    <div className="PS-container screen-container">
      <div className="screen-header">
        <div className="screen-header-text">
          <h1 className="screen-title">Care Providers</h1>
          <p className="screen-subtitle">
            Browse through our catalogue of care providers.
          </p>
        </div>
      </div>

      <div className="PS-grid">
        {isLoading ? (
          <div style={{ display: "flex", justifyContent: "center", width: "100%", gridColumn: "1 / -1", padding: "50px 0" }}>
            <img
              src={require("../images/loading_icon.gif")}
              alt="Loading providers"
              style={{ width: "50px" }}
            />
          </div>
        ) : (
          providers.map((provider, index) => (
            <CareProviderCard
              key={index}
              provider={provider}
              setSelectedSection={setSelectedSection}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default ProviderSelection;
